/** @format */
import {setAuthorizationHeader} from "../component/services/BaseApi";

export const setCookie = (cookieName, cookieValue, day = 0) => {
    document.cookie = cookieName + "=; Max-Age=0";
    const valuedCookie = cookieName + "=" + cookieValue;
    const date = new Date();
    date.setTime(+date + day * 86400000);
    document.cookie =
        valuedCookie +
        "; expires=" +
        (day !== 0 ? date.toGMTString() : "") +
        ";";
};
export const getCookie = (cookieName) => {
    const cookieNameArray = document.cookie.split(cookieName + "=");
    if (cookieNameArray.length === 2) {
        return cookieNameArray[1].split(";")[0];
    } else {
        return;
    }
};
export const delete_cookie = (name) => {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
export const createCookieThatLastsForADay = (cookieName, value) => {
    const date = new Date();
    const time_durring = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59
    );
    document.cookie = cookieName + "=; Max-Age=0";
    const valuedCookie = cookieName + "=" + value;
    document.cookie =
        valuedCookie + "; expires=" + time_durring.toGMTString() + ";";
    setAuthorizationHeader(getCookie("user_token"));
};


export const encodeToken = (token) => {
    const secretKey = process.env.REACT_APP_SECRET;
    const firstKey = btoa(secretKey);
    const newToken = firstKey + "@*" + token;
    return newToken;
};

export const decodeToken = (token) => {
    if (token.includes("@*")) {
        const lastToken = token.split("@*")[1];
        return lastToken;
    }
};
